import { Navigate, useParams } from "react-router-dom";
import { ShellPages } from "../apps/_shell/routes/shellPages";
import { useCurrentOrganisationId } from "../services/local/organisationContext/OrganisationContextModel";

export const NavigateToCurrentOrg: React.FC<any> = () => {
  const organisationId = useCurrentOrganisationId();
  return <Navigate to={ShellPages.dashboards.index.generateLink(organisationId)} />;
  // return <Navigate to={Pages.baseRoute.generateLink(organisationId)} />;
};

export const NavigateToCurrentHeatmap: React.FC<any> = () => {
  const organisationId = useCurrentOrganisationId();
  return (
    <Navigate to={ShellPages.organisations.visualisations.heatmap.generateLink(organisationId, "business-areas")} />
  );
};

export const NavigateToCurrentMyDashboard: React.FC<any> = () => {
  let { organisationId } = useParams();
  return <Navigate to={ShellPages.dashboards.index.generateLink(organisationId)} />;
};
